export { EventManager } from "./EventManager.js";